import request from '@/utils/request'

export default {
  // 验证码
  captchaImage(params) {
    // return Promise.resolve(data)
    return request({
      url: '/captchaImage',
      method: 'get',
      params
    })
  },
  // 登录
  login(data) {
    return request({
      url: '/login',
      method: 'post',
      data
    })
  },
  getInfo(params) {
    return request({
      url: '/getInfo',
      method: 'get',
      params
    })
  },
  // **********员工管理**********
  // 列表
  userList(params) {
    return request({
      url: '/system/user/list',
      method: 'get',
      params
    })
  },
  //所属部门
  userDept(params) {
    return request({
      url: '/system/dict/data/type/sys_dept',
      method: 'get',
      params
    })
  },
  userDel(data) {
    return request({
      url: `/system/user/${data.id}`,
      method: 'delete',
      data
    })
  },
  //新增
  userAdd(data) {
    return request({
      url: '/system/user',
      method: 'post',
      data
    })
  },
  // 详情
  userDetail(params) {
    return request({
      url: `/system/user/${params.id}`,
      method: 'get',
      params
    })
  },
  // 获取所有员工列表（key-value形式）
  userAllList(params) {
    return request({
      url: '/system/user/key-value-list',
      method: 'get',
      params
    })
  },
  //**********订单管理**********
  // 列表
  orderList(params) {
    return request({
      url: '/system/order/list',
      method: 'get',
      params
    })
  },
  // 已付款
  orderPay(data) {
    return request({
      url: '/system/order/paid',
      method: 'post',
      data
    })
  },
  paymentMethod(params) {
    return request({
      url: '/system/dict/data/type/payment_method',
      method: 'get',
      params
    })
  },
  //**********客户管理**********
  //列表
  customerList(params) {
    return request({
      url: '/system/customer/list',
      method: 'get',
      params
    })
  },
  //客户分类
  customerGroup(params) {
    return request({
      url: '/system/dict/data/type/customer_group',
      method: 'get',
      params
    })
  },
  //客户来源
  customerSource(params) {
    return request({
      url: '/system/dict/data/type/customer_source',
      method: 'get',
      params
    })
  },
  // 新增客户
  customerAdd(data) {
    return request({
      url: '/system/customer',
      method: 'post',
      data
    })
  },
  // 客户详情
  customerDetail(params) {
    return request({
      url: `/system/customer/${params.id}`,
      method: 'get',
      params
    })
  },
  // 删除客户
  customerDel(data) {
    return request({
      url: `/system/customer/${data.id}`,
      method: 'delete',
      data
    })
  },
  //**********项目相关管理**********
  //获取全部项目
  projectList(params) {
    return request({
      url: `/system/project/list`,
      method: 'get',
      params
    })
  },
  //获取当前客户项目列表
  customerProject(params) {
    return request({
      url: `/system/project/selectProjectByCustomerId/${params.id}`,
      method: 'get',
      params
    })
  },
  //获取项目类型project_type
  projectType(params) {
    return request({
      url: '/system/dict/data/type/project_type',
      method: 'get',
      params
    })
  },
  // 查询所有客户
  customerAll(params) {
    return request({
      url: '/system/customer/getAll',
      method: 'get',
      params
    })
  },
  //新增项目
  projectAdd(data) {
    return request({
      url: '/system/project',
      method: 'post',
      data
    })
  },
  // 删除项目
  projectDel(data) {
    return request({
      url: `/system/project/${data.id}`,
      method: 'delete',
      data
    })
  },
  // 根据项目ID查询修改记录列表
  projectModifyRecord(params) {
    return request({
      url: `/system/projectModifyRecord/project/${params.projectId}`,
      method: 'get'
    })
  },
  //**********报价管理**********
  //列表
  quotationList(params) {
    return request({
      url: '/system/quotation/list',
      method: 'get',
      params
    })
  },
  // 新增报价
  quotationAdd(data) {
    return request({
      url: '/system/quotation',
      method: 'post',
      data
    })
  },
  // 获取详情
  quotationDetail(params) {
    return request({
      url: `/system/quotation/${params.id}`,
      method: 'get',
      params
    })
  },
  //删除
  quotationDel(data) {
    return request({
      url: `/system/quotation/${data.id}`,
      method: 'delete',
      data
    })
  },
  // 复制报价
  quotationCopy(data) {
    return request({
      url: '/system/quotation/copy',
      method: 'post',
      data
    })
  },
  //同意报价
  quotationAgree(data) {
    return request({
      url: '/system/quotation/agree',
      method: 'post',
      data
    })
  },
  //下载报价
  quotationDownload(params) {
    return request({
      url: `/system/quotation/printInvoice/${params.id}`,
      method: 'get'
    })
  },
  //**********发票管理**********
  //列表
  invoiceList(params) {
    return request({
      url: '/system/invoice/list',
      method: 'get',
      params
    })
  },
  //编辑发票
  invoiceEdit(data) {
    return request({
      url: '/system/invoice/details',
      method: 'post',
      data
    })
  },
  //下载发票
  invoiceDownload(params) {
    return request({
      url: `/system/invoice/printInvoice/${params.id}`,
      method: 'get'
    })
  },
  // 查询客户对应的发票列表
  customerInvoice(params) {
    return request({
      url: `/system/invoice/getByCustomerId/${params.id}`,
      method: 'get'
    })
  },
  // 获取发票详细信息
  detailInvoice(params) {
    return request({
      url: `/system/invoice/${params.id}`,
      method: 'get'
    })
  },
  //**********收据管理**********
  //列表
  receiptList(params) {
    return request({
      url: '/system/receipt/list',
      method: 'get',
      params
    })
  },
  //添加
  receiptAdd(data) {
    return request({
      url: '/system/receipt',
      method: 'post',
      data
    })
  },
  //删除
  receiptDel(data) {
    return request({
      url: `/system/receipt/${data.id}`,
      method: 'delete',
      data
    })
  },
  //详情
  receiptDetail(params) {
    return request({
      url: `/system/receipt/${params.id}`,
      method: 'get',
      params
    })
  },
  // 编辑
  receiptEdit(data) {
    return request({
      url: '/system/receipt/details',
      method: 'post',
      data
    })
  },
  //下载发票
  receiptDownload(params) {
    return request({
      url: `/system/receipt/printInvoice/${params.id}`,
      method: 'get'
    })
  },
  //**********服务管理**********
  //服务类别列表
  categoryList(params) {
    return request({
      url: '/system/category/list',
      method: 'get',
      params
    })
  },
  //服务类别新增
  categoryAdd(data) {
    return request({
      url: '/system/category',
      method: 'post',
      data
    })
  },
  //服务类别删除
  categoryDel(data) {
    return request({
      url: `/system/category/${data.id}`,
      method: 'delete',
      data
    })
  },
  //服务列表
  serviceList(params) {
    return request({
      url: '/system/service/list',
      method: 'get',
      params
    })
  },
  //服务新增
  serviceAdd(data) {
    return request({
      url: '/system/service',
      method: 'post',
      data
    })
  },
  //服务类别删除
  serviceDel(data) {
    return request({
      url: `/system/service/${data.id}`,
      method: 'delete',
      data
    })
  },
  //**********供应商管理**********
  //供应商列表
  supplierList(params) {
    return request({
      url: '/system/supplier/list',
      method: 'get',
      params
    })
  },
  //供应商新增
  supplierAdd(data) {
    return request({
      url: '/system/supplier',
      method: 'post',
      data
    })
  },
  //供应商删除
  supplierDel(data) {
    return request({
      url: `/system/supplier/${data.id}`,
      method: 'delete',
      data
    })
  },
  // 获取供应商文件集合
  supplierFileList(params) {
    return request({
      url: `/system/supplier-file/supplier/${params.id}`,
      method: 'get'
    })
  },
  // 供应商文件上传
  supplierFileAdd(data) {
    return request({
      url: '/system/supplier-file/upload',
      method: 'post',
      data
    })
  },
  //供应商文件删除
  supplierFileDel(data) {
    return request({
      url: `/system/supplier-file/${data.id}`,
      method: 'delete',
      data
    })
  },
  //供应商文件下载
  supplierFileDownload(data) {
    return request({
      url: `/system/supplier-file/download/${data.id}`,
      method: 'delete',
      data
    })
  },
  //**********成本管理**********
  // 获取财务科目
  financeSubject(params) {
    return request({
      url: '/system/dict/data/type/sys_finance_subject',
      method: 'get',
      params
    })
  },
  //成本类型列表
  costTypeList(params) {
    return request({
      url: '/system/type/list',
      method: 'get',
      params
    })
  },
  //成本类型新增
  costTypeAdd(data) {
    return request({
      url: '/system/type',
      method: 'post',
      data
    })
  },
  //成本来源列表
  costSourceList(params) {
    return request({
      url: '/system/source/list',
      method: 'get',
      params
    })
  },
  //成本来源新增
  costSourceAdd(data) {
    return request({
      url: '/system/source',
      method: 'post',
      data
    })
  },
  //成本列表
  costList(params) {
    return request({
      url: '/system/cost/list',
      method: 'get',
      params
    })
  },
  //成本新增
  costAdd(data) {
    return request({
      url: '/system/cost',
      method: 'post',
      data
    })
  },
  // 查询供应商全部
  supplierAll(params) {
    return request({
      url: '/system/supplier/getAll',
      method: 'get',
      params
    })
  },
  //成本删除
  costDel(data) {
    return request({
      url: `/system/cost/${data.id}`,
      method: 'delete',
      data
    })
  },
  // 成本统计
  costStatistics(params) {
    return request({
      url: '/system/cost/statistics',
      method: 'get',
      params
    })
  },
  // 统计相关
  // 获取客户统计信息
  customerStatistics(params) {
    return request({
      url: '/system/customer/statistics',
      method: 'get',
      params
    })
  },
  // 获取报价统计信息
  quotationStatistics(params) {
    return request({
      url: '/system/quotation/statistics',
      method: 'get',
      params
    })
  },
  // 获取项目统计信息
  projectStatistics(params) {
    return request({
      url: '/system/project/statistics',
      method: 'get',
      params
    })
  },
  // 获取发票统计信息
  invoiceStatistics(params) {
    return request({
      url: '/system/invoice/statistics',
      method: 'get',
      params
    })
  },
  // 获取简单成本统计
  costsimpleStatistics(params) {
    return request({
      url: '/system/cost/simpleStatistics',
      method: 'get',
      params
    })
  },
  //**********公告管理**********
  //获取通知公告列表
  noticeList(params) {
    return request({
      url: '/system/notice/list',
      method: 'get',
      params
    })
  },
  //通知公告新增
  noticeAdd(data) {
    return request({
      url: '/system/notice',
      method: 'post',
      data
    })
  },
  //删除通知公告
  noticeDel(data) {
    return request({
      url: `/system/notice/${data.id}`,
      method: 'delete',
      data
    })
  },
  // 推送用户
  noticePush(data) {
    return request({
      url: '/system/notice/push',
      method: 'post',
      data
    })
  },
  //**********系统设置管理**********
  //获取列表
  systemList(params) {
    return request({
      url: '/system/dict/type/list',
      method: 'get',
      params
    })
  },
  //新增字典类型
  systemAdd(data) {
    return request({
      url: '/system/dict/data',
      method: 'post',
      data
    })
  },
  //获取详情列表
  systemDetail(params) {
    return request({
      url: `/system/dict/data/list`,
      method: 'get',
      params
    })
  },
  //**********账户信息**********
  //获取账户信息详细信息 1的是账户信息，2是发票抬头
  accountList(params) {
    return request({
      url: `/system/account/${params.id}`,
      method: 'get'
    })
  },
  accountEdit(data) {
    return request({
      url: '/system/account',
      method: 'put',
      data
    })
  },
  //**********首页接口**********
  //获取是否有新订单
  indexOrder(params) {
    return request({
      url: `/system/order/has-new-order`,
      method: 'get',
      params
    })
  },
  // 首页获取用户的公告列表
  indexNotice(params) {
    return request({
      url: `/system/notice/user-notices`,
      method: 'get',
      params
    })
  },
  // 获取当前登录用户的未读公告数量
  indexNoticeCount(params) {
    return request({
      url: `/system/notice/unread-count`,
      method: 'get',
      params
    })
  },
  // 将用户所有未读公告标记为已读
  indexNoticeRead(params) {
    return request({
      url: `/system/notice/mark-all-read`,
      method: 'put',
      params
    })
  },
  //**********数据分析接口**********
  // 获取订单收入统计数据
  OrderAnalysis(params) {
    return request({
      url: `/system/data-analysis/order-income-statistics`,
      method: 'get',
      params
    })
  },
  // 获取近一年的收入趋势数据
  trendYearly(params) {
    return request({
      url: `/system/data-analysis/income-trend-yearly`,
      method: 'get',
      params
    })
  }
}
